import { useState, type ReactNode } from 'react'
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { ApiError } from '@/api/client'

// Single-operator internal tool: a failed request should surface
// immediately, not silently retry three times with backoff.
function isSessionExpired(error: unknown): boolean {
  return error instanceof ApiError && error.code === 'GUI_AUTH_001_INVALID_TOKEN'
}

export function AppQueryProvider({ children }: { children: ReactNode }) {
  const navigate = useNavigate()

  const [queryClient] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: (error) => {
            if (isSessionExpired(error)) navigate('/access')
          },
        }),
        mutationCache: new MutationCache({
          onError: (error) => {
            if (isSessionExpired(error)) navigate('/access')
          },
        }),
        defaultOptions: {
          queries: { retry: false },
          mutations: { retry: false },
        },
      }),
  )

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
